// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : LAST EMI DETAILS REDUCER CREATED
// MODIFIED DATE: 16-09-2025

/* eslint-disable import/no-anonymous-default-export */
import LastEMIDetailsActionTypes from './last-emi-details.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// LAST EMI DETAILS RESPONSE
	getLastEMIDetailsResponse: null,
	getLastEMIDetailsArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET GOLD LOAN MEMBER DETAILS START *********************** */
		case LastEMIDetailsActionTypes.GET_LAST_EMI_DETAILS_SUCCESS:
			return {
				...state,
				getLastEMIDetailsResponse: action.payload,
				getLastEMIDetailsArr: docodeHexResponse(
					action.payload,
					'GetLastEMIDetailsRecordKey',
				),
			};

		case LastEMIDetailsActionTypes.GET_LAST_EMI_DETAILS_FAILURE:
			return {
				...state,
				getLastEMIDetailsResponse: action.payload,
				getLastEMIDetailsArr: [],
			};

		case LastEMIDetailsActionTypes.GET_LAST_EMI_DETAILS_RESPONSE_CHANGED:
			return { ...state, getLastEMIDetailsResponse: null };

		/** ***************** GET GOLD LOAN MEMBER DETAILS END *********************** */
		default:
			return state;
	}
};
